import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetFormModal.translations.json';
import { AlgorithmElementFunctionViewType } from '../../types';
import { AlgorithmConditionForm } from '../algorithmCondition/AlgorithmConditionForm';
import { Flex } from 'antd';
import { FormField } from '../../../common/form';
import { AlgorithmTargetItemDimensionIndicatorSelect } from './AlgorithmTargetItemDimensionIndicatorSelect';
import { AddRemoveButtons } from '../../../common/components';
import { useWatch } from 'react-hook-form';
import { useAlgorithmTargetRuleOptions } from './ruleOptions/useAlgorithmTargetRuleOptions';
import { AlgorithmSourceFormDataType } from '../sources/schema/types';
import type { AlgorithmMappingQueryDtoType } from '../mappings/schema/types';
import { AlgorithmType } from '../schema/zAlgorithmType';
import { DataObjectDescriptionVersionStore } from '../../DataObjectDescriptionVersionStore';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-target-modal',
);
addTranslations(translations);

interface AlgorithmTargetRuleTypeFieldProps {
  algorithmTypeCode: AlgorithmType;
  index: number;
  isLast: boolean;
  onAdd: () => void;
  onRemove: (index: number) => void;
  sources: AlgorithmSourceFormDataType[];
  mappings: AlgorithmMappingQueryDtoType[];
}

export function AlgorithmTargetRuleTypeField({
  algorithmTypeCode,
  index,
  isLast,
  onAdd,
  onRemove,
  sources,
  mappings,
}: AlgorithmTargetRuleTypeFieldProps) {
  const { t } = useTranslation();
  const [dataObjectDescriptionVersion] =
    DataObjectDescriptionVersionStore.useValue('dataObjectDescriptionVersion');
  const dimensionIndicators: string[] = useWatch({
    name: `rules.${index}.dimensionIndicators`,
  });

  const { targetOptions } = useAlgorithmTargetRuleOptions({
    algorithmTypeCode,
    dataObjectVersion: dataObjectDescriptionVersion,
    sources,
    mappings,
    currentTargetValue: dimensionIndicators,
  });

  return (
    <Flex vertical gap="middle">
      <Flex gap="middle">
        <FormField
          preview={{
            previewOnly: true,
          }}
          size="small"
          name={`rules.${index}.ruleCode`}
          label={t('ruleCode.label')}
        />
        <AlgorithmTargetItemDimensionIndicatorSelect
          index={index}
          options={targetOptions}
        />
        <AddRemoveButtons
          id={`algorithmTargetRuleType-control-${index}`}
          onClickAdd={isLast ? onAdd : undefined}
          onClickRemove={() => onRemove(index)}
        />
      </Flex>
      <AlgorithmConditionForm
        required
        name={`rules.${index}.expression`}
        label={t('expression.label')}
        rows={3}
        viewType={AlgorithmElementFunctionViewType.R}
        sources={sources}
        mappings={mappings}
      />
    </Flex>
  );
}
